<template>
  <div class="powered-by-container">
    <div class="powered-by">
      <span>{{ $tI('POWERED BY') }} </span>
      <a target="_blank" href="https://illustrativedna.com/">
        <img src="https://illustrativedna.com/wp-content/uploads/2020/06/illustrativedna-logo.png" height="20px"/>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.powered-by-container {
  margin-top: auto;
  margin-bottom: 20px;
  .powered-by {
    text-align: center;
  }
  span {
    color: var(--black-100);
    font-size: 11px;
    font-weight: 500;
  }
}


</style>
